import { type Country } from '@capsicum/common';

export const ORDER_FIELD_MAPPINGS = {
	addressCity: 'address.city',
	addressCountryCode: 'address.countryCode',
	addressRegion: 'address.region',
	addressStreet: 'address.street',
	addressZipcode: 'address.zipCode',
	birthCountry: 'birthCountry',
	birthDate: 'birthDate',
	documentIdNumber: 'userProvidedValues.documentNumber',
	documentType: 'userProvidedValues.documentType',
	email: 'email',
	expiryDate: 'userProvidedValues.documentExpiry',
	firstName: 'firstName',
	issuingCountry: 'userProvidedValues.documentIssuingCountry',
	lastName: 'lastName',
	mobileNumber: 'mobileNumber'
} as const;

export const USER_PROVIDED_VALUES_PREFIX = 'userProvidedValues.';
export type OrderFieldKey = keyof typeof ORDER_FIELD_MAPPINGS;

export type DocumentType = {
	id: number;
	name: string;
};

export type FieldType = {
	displayOrder: number;
	fieldCategory: string;
	fieldType: string;
	id: string;
	isEditable: boolean;
	isOptional: boolean;
	name: string;
	options: {
		isCountryList?: boolean;
		isDocumentTypeList?: boolean;
		mustBeFutureDate?: boolean;
		mustBePastDate?: boolean;
		values?: Array<string>;
	};
	placeholder: string;
	value: Country | DocumentType | null | string;
};

export type FieldsObject = {
	[key: string]: Array<FieldType>;
};
